import React from 'react'
import image from '../../../assets/homepage_logo.png';
import image2 from '../../../assets/homepage_paypal.png';
const FooterSectionOne = () => {
    return (
        <>
            <div className="f-logo">
                <a href="#">
                    <img src={image} alt="" className="logo-black" />
                    <img src="images/logo-w.png" alt="" className="logo-white" />
                </a>
            </div>
            <p className="address-pera">
                Jahir Smart Tower <br />
                205/1 &amp; 205/1/A, West Kafrul, Begum Rokeya Sharani, Taltola,
                Dhaka-1207.
            </p>
            <p className="address-pera">
                Phone: <a href="tel:8809678100530">+8809678-100530</a>
            </p>
            <p className="address-pera">
                Email: <a href="mailto:info@eerna.com">info@eerna.com</a>
            </p>
            <hr className="my-3" />
            <p className="copyright">
                Copyright 2021 <span>©hrventure</span> design by bellal
            </p>
            <a href="#" className="paypal">
                <img className="img-fluid" src={image2} alt="" />
            </a>
        </>
    )
}

export default FooterSectionOne